module.exports = __webpack_public_path__ + "static/fonts/Jost-Bold.90fc0121.ttf";